module.exports = __webpack_public_path__ + "img/tna.2647483.png";